// @ts-nocheck
import { LICENSE_ADJUSTMENT_ERROR, LICENSE_ADJUSTMENT_LOADING, LICENSE_ADJUSTMENT_SUCCESS} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ''
}

export const LicenseAdjustmentReducer = (state = initialState, action) => {
    switch (action.type) {
        case LICENSE_ADJUSTMENT_LOADING:
            return Object.assign({}, state, { loading: true })
        case LICENSE_ADJUSTMENT_SUCCESS:
            return Object.assign({}, state, { payload: action.data, loading: false })
        case LICENSE_ADJUSTMENT_ERROR:
            return Object.assign({}, state, { payload: action.data, loading: false })
        default:
            return state
    }
}

